// extracted by mini-css-extract-plugin
export default {"bold":"FGGWkC0_GK8_EI_WmO5J"};